import { render, staticRenderFns } from "./LkNotificationsAdmin.vue?vue&type=template&id=4adc5979&scoped=true"
import script from "./LkNotificationsAdmin.vue?vue&type=script&lang=js"
export * from "./LkNotificationsAdmin.vue?vue&type=script&lang=js"
import style0 from "./LkNotificationsAdmin.vue?vue&type=style&index=0&id=4adc5979&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adc5979",
  null
  
)

export default component.exports